import { render } from "./AddCommandFormFilterList.vue?vue&type=template&id=2b5428ee"
import script from "./AddCommandFormFilterList.vue?vue&type=script&lang=js"
export * from "./AddCommandFormFilterList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fLte45evJ/0/trinax/jeopardy.trinax.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__